export function handle(input) {
    input.addEventListener("focus", (event) => {
        if (!input.value.length) {
            input.value = "@";
        }
    });

    input.addEventListener("blur", (event) => {
        if (input.value === "@") {
            input.value = "";
        }
        else if (input.value.indexOf("@") !== 0 && input.value.length) {
            input.value = "@" + input.value;
        }
    });
}

export function handleAll() {
    document.querySelectorAll("[data-tg-username-input]")
        .forEach(handle);
}
